const NewsPageShowView = () => import("@/views/news/NewsPageShowView.vue")

export const newsPages = [
    {
        path: '/news/:url',
        name: 'news.view',
        component: NewsPageShowView
    },
];